import {
  UserRole,
  isAdminRole,
  isDistributorRole,
  isSalesRole,
} from '@lombok/shared';

/**
 * Maps a backend UserRole to the frontend route group. This is a UX convenience
 * for redirects and navigation only — the BACKEND is the sole authority on what
 * each role may actually read or write.
 */
export type RouteGroup = 'admin' | 'sales' | 'customer' | 'distributor' | 'warehouse';

export function routeGroupForRole(role: UserRole): RouteGroup {
  if (isAdminRole(role) || role === UserRole.FINANCE) return 'admin';
  if (role === UserRole.WAREHOUSE || role === UserRole.DRIVER) return 'warehouse';
  if (isSalesRole(role)) return 'sales';
  if (isDistributorRole(role)) return 'distributor';
  return 'customer';
}

/** Default landing path after login, by role. */
export function homePathForRole(role: UserRole): string {
  return `/app/${routeGroupForRole(role)}`;
}

/** Roles permitted to view a given route group (UX gate only). */
export const ROLES_BY_GROUP: Record<RouteGroup, readonly UserRole[]> = {
  admin: [UserRole.SUPER_ADMIN, UserRole.ADMIN, UserRole.FINANCE],
  sales: [UserRole.SALES_MANAGER, UserRole.SALES_REP],
  customer: [UserRole.CUSTOMER_USER],
  distributor: [UserRole.DISTRIBUTOR_ADMIN, UserRole.DISTRIBUTOR_USER],
  warehouse: [UserRole.WAREHOUSE, UserRole.DRIVER],
};

/** Human-readable Spanish label for a role (UI display only). */
export const ROLE_LABELS_ES: Record<UserRole, string> = {
  super_admin: 'Super administrador',
  admin: 'Administrador',
  finance: 'Finanzas',
  warehouse: 'Almacén',
  sales_manager: 'Gerente de ventas',
  sales_rep: 'Vendedor',
  customer_user: 'Cliente',
  distributor_admin: 'Administrador de distribuidor',
  distributor_user: 'Usuario de distribuidor',
  driver: 'Conductor',
};
